module.exports = __webpack_public_path__ + "img/shutterstock_1401229586.aa8ade6b.jpg";